import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../services/apiService";

const MCC_SELECT_FETCH_LIST = "mccSelectField/fetchList";
const MCC_SELECT_RESOLVE_CODE = "mccSelectField/resolveByCode";

export const MCC_PAGE_SIZE = 50;

const mapMccRow = ({ mcc, description }) => ({
  id: String(mcc || "").trim(),
  label: `${String(mcc || "").trim()} - ${String(description || "").trim()}`,
  description: String(description || "").trim(),
});

export const fetchMccList = createAsyncThunk(
  MCC_SELECT_FETCH_LIST,
  async (payload, { rejectWithValue }) => {
    const {
      token,
      search = "",
      page = 1,
      pageSize = MCC_PAGE_SIZE,
      append = false,
    } = payload;
    const params = new URLSearchParams({
      page: String(page),
      page_size: String(pageSize),
    });
    const trimmedSearch = String(search || "").trim();
    if (trimmedSearch) {
      params.set("search", trimmedSearch);
    }
    const url = `/mcc?${params.toString()}`;
    try {
      const body = await get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const rows = Array.isArray(body?.data) ? body.data : [];
      return {
        items: rows.map(mapMccRow).filter((row) => row.id),
        search: trimmedSearch,
        page: body?.page ?? page,
        pageSize: body?.page_size ?? pageSize,
        totalRecords: body?.total_records ?? rows.length,
        append: Boolean(append),
      };
    } catch (error) {
      console.error("Error fetching MCC list:", error);
      return rejectWithValue({
        message: error?.response?.data?.detail || error?.message || "Error loading MCC catalog",
      });
    }
  },
);

export const resolveMccByCode = createAsyncThunk(
  MCC_SELECT_RESOLVE_CODE,
  async (payload, { rejectWithValue }) => {
    const { token, code } = payload;
    const trimmed = String(code || "").trim();
    if (!trimmed) {
      return rejectWithValue({ message: "MCC code is required" });
    }
    try {
      const body = await get(`/mcc/${encodeURIComponent(trimmed)}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return mapMccRow(body);
    } catch (error) {
      console.error("Error resolving MCC code:", error);
      return rejectWithValue({
        message: error?.response?.data?.detail || error?.message || "MCC not found",
        code: trimmed,
      });
    }
  },
);
